module.exports = __webpack_public_path__ + "img/logo-full.f2a852ba.svg";